import { Divider } from '@mui/material';
import React from 'react';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Input } from 'src/@/components/ui/input';
import { Switch } from 'src/@/components/ui/switch';

export default function HorariosAtendimento({
    config,
    changeConfig
}) {

    const diasSemana = [
        { dia: "Domingo", numeroDia: 0 },
        { dia: "Segunda-feira", numeroDia: 1 },
        { dia: "Terça-feira", numeroDia: 2},
        { dia: "Quarta-feira", numeroDia: 3 },
        { dia: "Quinta-feira", numeroDia: 4 },
        { dia: "Sexta-feira", numeroDia: 5 },
        { dia: "Sábado", numeroDia: 6 },
    
    ];


    const toggleDayHidden = (numeroDia) => {
        changeConfig((prevConfig) => {
            const daysHidden = prevConfig.daysHidden.includes(numeroDia.toString())
                ? prevConfig.daysHidden.filter((day) => day !== numeroDia.toString())
                : [...prevConfig.daysHidden, numeroDia.toString()];

            return {
                ...prevConfig,
                daysHidden
            };
        });
    };

    return (
        <div className='flex flex-col gap-4'>
        <div>
            <h2 className="text-md font-bold mb-1">Ocultar dias no calendário</h2>
            <p className="text-sm">Escolha abaixo os dias que deseja ocultar no calendário.</p>

            <div className="p-2 rounded-lg flex flex-row mt-4 gap-4">
                {diasSemana.map((horario, index) => (
                    <div key={index} className="flex">
                        <div className="flex items-center gap-2 w-[120px]">
                            <Checkbox
                                checked={config?.daysHidden.includes(horario.numeroDia.toString())}
                                onCheckedChange={() => toggleDayHidden(horario.numeroDia)}
                            />
                            <span className="text-sm">{`${horario.dia}`}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>

        <Divider className='border-dashed' />


        <div>
            <h2 className="text-md font-bold mb-1">Horários permitidos</h2>
            <p className="text-sm">Escolha abaixo os horarios que deseja no calendário</p>
            <div className='flex flex-row gap-4'>
                <div className="w-24">
                    <label className="text-sm text-gray-600">Inicio</label>
                    <input
                        type="time"
                        name="time_start"
                        value={config?.startTime}
                        onChange={e => {
                            changeConfig((prevConfig) => {
                                return {
                                    ...prevConfig,
                                    startTime: e.target.value,
                                };
                            });
                        }}
                        className="border px-2 h-8 rounded-md mt-1.5 w-full bg-slate-100"
                    />
                </div>
                <div className="w-24">
                    <label className="text-sm text-gray-600">Final</label>
                    <input
                        type="time"
                        name="time_end"
                        value={config?.endTime}
                        onChange={e => {
                            changeConfig((prevConfig) => {
                                return {
                                    ...prevConfig,
                                    endTime: e.target.value
                                };
                            });
                        }}
                        className="border px-2 h-8 rounded-md mt-1.5 w-full bg-slate-100"
                    />
                </div>

         
            </div>

            </div>
            <Divider className='border-dashed' />

            <div>
            <h2 className="text-md font-bold mb-1">Duração</h2>
            <p className="text-sm mt-2">Defina um slot de duração para cada evento no calenário</p>
            <div className="w-24 flex flex-row gap-2 items-center">
                    <input
                        type="time"
                        value={config?.slotDuration}
                        onChange={e => {
                            changeConfig((prevConfig) => {
                                return {
                                    ...prevConfig,
                                    slotDuration: e.target.value
                                };
                            });
                        }}
                        className="border px-2 h-6 rounded-md mt-1.5 bg-slate-100"
                    />
                </div>
                </div>
      
    </div>

    );
}
